if (!customElements.get("image-comparison-slider")) {
  customElements.define(
    "image-comparison-slider",
    class ImageComparisonSlider extends HTMLElement {
      constructor() {
        super();
        this.container = this.querySelector(".image-comparison__container");
        this.inputRange = this.querySelector(".image-comparison__slider");
        this.selectRadios = this.querySelectorAll(
          '.image-comparison__selectors input[type="radio"]',
        );
        this.beforeImage = this.querySelector(
          ".image-comparison__image-before",
        );
        this.afterImage = this.querySelector(".image-comparison__image-after");
        this.initRangeSlider();
        this.initRadios();
      }

      initRangeSlider() {
        if (!(this.inputRange && this.container)) return;
        this.inputRange.addEventListener("input", (e) => {
          this.container.style.setProperty(
            "--image-comparison-position",
            `${e.target.value}%`,
          );
        });
      }

      onRadioChange(e) {
        if (
          this.beforeImage &&
          this.afterImage &&
          e.currentTarget &&
          e.currentTarget.dataset &&
          e.currentTarget.dataset.beforeUrl &&
          e.currentTarget.dataset.afterUrl
        ) {
          this.beforeImage.src = e.currentTarget.dataset.beforeUrl;
          this.beforeImage.setAttribute(
            "srcset",
            e.currentTarget.dataset.beforeUrl +
              "&width=500&height=500&crop=center 500w, " +
              e.currentTarget.dataset.beforeUrl +
              "&width=1300 1300w",
          );
          this.afterImage.src = e.currentTarget.dataset.afterUrl;
          this.afterImage.setAttribute(
            "srcset",
            e.currentTarget.dataset.afterUrl +
              "&width=500&height=500&crop=center 500w, " +
              e.currentTarget.dataset.afterUrl +
              "&width=1300 1300w",
          );
        }
      }

      initRadios() {
        if (!(this.selectRadios && this.selectRadios.length)) return;
        [].forEach.call(this.selectRadios, (radio) => {
          radio.addEventListener("input", this.onRadioChange.bind(this));
        });
      }
    },
  );
}
